<template>
  <div class="layout">
    <table width="100%" class="mar5-b mar5-t">
      <tbody>
        <tr>
          <td class="pad10-r" width="5px">
            <div class="dashboard-info-fecha-fecha">
              <div class="dashboard-info-fecha-fecha-0">{{ fechadia }}</div>
              <div>
                <div class="dashboard-info-fecha-fecha-1">{{ fechames }}</div>
                <div class="dashboard-info-fecha-fecha-2">{{ fechaano }}</div>
              </div>
            </div>
          </td>

          <td class="borde-r" width="5px">
            <div class="info-box-title font-oswald">Dashboard</div>
          </td>

          <td width="5px">
            <div v-if="loading">
              <img src="dist/img/kubber-construyendo.gif" style="width: 30px" />
            </div>
          </td>

          <td style="text-align: right">
            <img src="dist/img/kubber-logo-transparente.png" style="height: 30px; opacity: 0.5" alt="Kubber" />
          </td>
        </tr>
      </tbody>
    </table>

    <div>
      <div class="row">
        <div class="col-6 col-sm-6 col-md-2" v-for="combustible in combutibles"
          :key="combustible.producto_id || combustible.producto_nombre">
          <div class="info-box-lg">
            <div class="info-box-lg-text">
              {{ combustible.producto_nombre }}
            </div>
            <div class="info-box-lg-precio">
              {{ GLOBAL.FORMATO_MONEY_BASIC(combustible.total || 0) }}
            </div>
            <div class="info-box-lg-volumen">
              {{ GLOBAL.FORMATO_NUMBER(combustible.cantidad || 0) }}
              <span style="font-size: 15px">{{ combustible.unidad_codigo }}</span>
            </div>
          </div>
        </div>
      </div>

      <br />

      <div class="row">
        <div class="col-6 col-sm-6 col-md-2">
          <div class="info-box">
            <span class="info-box-icon bg-teal elevation-1">
              <i class="fa-solid fa-receipt" aria-hidden="true"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">Nro de Ventas</span>
              <span class="info-box-number">
                {{ numeroVenta }}
                <span v-if="diffVenta > 0" class="float-right text-success">
                  <i class="fas fa-arrow-up text-sm" aria-hidden="true"></i>
                  +{{ diffVenta }}
                </span>
              </span>
            </div>
          </div>
        </div>

        <div class="col-6 col-sm-6 col-md-2">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-blue elevation-1">
              <i class="fa-solid fa-bottle-water" aria-hidden="true"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">Totales Canas.</span>
              <span class="info-box-number">
                {{ GLOBAL.FORMATO_MONEY_BASIC(totalVentaCanastilla || 0) }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-6 col-sm-6 col-md-2">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-yellow elevation-1">
              <i class="fa-solid fa-people-group" aria-hidden="true"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">Clientes Registrados</span>
              <span class="info-box-number">
                {{ cantidadClientes }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-6 col-sm-6 col-md-2">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-purple elevation-1">
              <i class="fa-solid fa-file-invoice-dollar" aria-hidden="true"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">F.Electronicas</span>
              <span class="info-box-number">
                {{ cantidadFElectronica }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-6 col-sm-6 col-md-2">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-mulberry elevation-1">
              <i class="fa-solid fa-delete-left" aria-hidden="true"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">Ventas Anuladas</span>
              <span class="info-box-number">
                {{ cantidadAnuladas }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-6 col-sm-6 col-md-2">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-green elevation-1">
              <i class="fa-solid fa-file-invoice" aria-hidden="true"></i>
            </span>
            <div class="info-box-content">
              <span class="info-box-text">Ultima Fact.</span>
              <span class="info-box-table">
                <div class="info-box-sub-1">
                  {{ GLOBAL.FORMATO_MONEY_BASIC(ultima.total || 0) }}
                </div>
                <div class="info-box-sub-2">
                  {{ GLOBAL.FORMATO_NUMBER(ultima.cantidad || 0) }}
                  <span class="b" style="font-size: 11px">{{ ultima.unidad || "" }}</span>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <FuelTanks :tanks="tanquesCombustible" subtitle="Nivel actual por tanque" :warnPct="25" :critPct="10" />
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="card card-borde">
            <div class="card-body p-0">
              <table class="table table-striped table-valign-middle table-dashboard">
                <thead>
                  <tr>
                    <th>
                      <i class="fa-solid fa-gas-pump" aria-hidden="true"></i>
                      Reporte Mensual de Combustible
                    </th>
                    <th class="text-right">Cantidad</th>
                    <th class="text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in ventasCombustible" :key="item._id">
                    <td>{{ item.producto_nombre }}</td>
                    <td class="text-right">
                      {{ GLOBAL.FORMATO_NUMBER(item.cantidad || 0) }}
                      <span style="font-size: 13px">{{ item.unidad_codigo }}</span>
                    </td>
                    <td class="text-right">
                      {{ GLOBAL.FORMATO_MONEY_BASIC(item.total || 0) }}
                    </td>
                  </tr>
                  <tr v-if="!ventasCombustible.length">
                    <td colspan="3" class="text-center" style="opacity: 0.7">Sin datos</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="ventasDespachos.length">
        <div class="col-lg-12">
          <div class="card card-borde">
            <div class="card-body p-0">
              <table class="table table-striped table-valign-middle table-dashboard">
                <thead>
                  <tr>
                    <th>
                      <i class="fa-solid fa-truck" aria-hidden="true"></i>
                      Reporte Mensual Crédito Despachos
                    </th>
                    <th class="text-right">#Despachos</th>
                    <th class="text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in ventasDespachos" :key="item._id">
                    <td>{{ item.tercero_nombre }}</td>
                    <td class="text-right">
                      {{ GLOBAL.FORMATO_NUMBER_BASIC(item.cantidad || 0) }}
                    </td>
                    <td class="text-right">
                      {{ GLOBAL.FORMATO_MONEY_BASIC(item.total || 0) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div class="card card-borde">
            <div class="card-body p-0">
              <table width="100%" class="table table-striped table-valign-middle table-dashboard">
                <thead>
                  <tr>
                    <th>Ventas con Mayor CANTIDADES (MES)</th>
                    <th width="10%">Cantidad</th>
                    <th width="10%">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in ventasCanastillaCantidad" :key="item._id">
                    <td>{{ item.producto_nombre }}</td>
                    <td class="text-right">
                      {{ GLOBAL.FORMATO_NUMBER_BASIC(item.cantidad || 0) }}
                      <span style="font-size: 13px">{{ item.unidad_codigo }}</span>
                    </td>
                    <td class="text-right">
                      {{ GLOBAL.FORMATO_MONEY_BASIC(item.total || 0) }}
                    </td>
                  </tr>
                  <tr v-if="!ventasCanastillaCantidad.length">
                    <td colspan="3" class="text-center" style="opacity: 0.7">Sin datos</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="card card-borde">
            <div class="card-body p-0">
              <table class="table table-striped table-valign-middle table-dashboard">
                <thead>
                  <tr>
                    <th>Ventas con Mayor TOTALES (MES)</th>
                    <th width="10%">Cantidad</th>
                    <th width="10%">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in ventasCanastillaVenta" :key="item._id">
                    <td>{{ item.producto_nombre }}</td>
                    <td class="text-right">
                      {{ GLOBAL.FORMATO_NUMBER_BASIC(item.cantidad || 0) }}
                      <span style="font-size: 13px">{{ item.unidad_codigo }}</span>
                    </td>
                    <td class="text-right">
                      {{ GLOBAL.FORMATO_MONEY_BASIC(item.total || 0) }}
                    </td>
                  </tr>
                  <tr v-if="!ventasCanastillaVenta.length">
                    <td colspan="3" class="text-center" style="opacity: 0.7">Sin datos</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <br />

      <div class="row">
        <div class="col-lg-6">
          <div class="elevation-1 round-3 highcharts-light" id="container1"></div>
        </div>
        <div class="col-lg-6">
          <div class="elevation-1 round-3 highcharts-light" id="container2"></div>
        </div>
      </div>

      <br />

      <div class="row">
        <div class="col-lg-12">
          <div class="elevation-1 round-3 highcharts-light" id="container3"></div>
        </div>
        <div class="col-lg-12">
          <div class="elevation-1 round-3 highcharts-light" id="container4"></div>
        </div>
      </div>

      <br />
    </div>
  </div>
</template>



<script>
import router from "../router";
import GLOBAL from "../Global.js";
import DashboardService from "../service/DashboardService";
import FuelTanks from "../components/FuelTanks.vue";

export default {
  components: { FuelTanks },
  data() {
    return {
      GLOBAL,
      dashboardService: null,

      // fechas
      fechauno: "",
      fechainicio: "",
      fechafin: "",
      fechadia: "",
      fechames: "",
      fechaano: "",

      // años dinámicos
      anoActual: "",
      anoAnterior: "",

      // resumen
      numeroVenta: 0,
      diffVenta: 0,
      combutibles: [],
      totalVentaCombustible: 0,
      totalVentaCanastilla: 0,
      cantidadVenta: 0,
      cantidadFElectronica: 0,
      cantidadClientes: 0,
      cantidadAnuladas: 0,
      unidadCodigo: "",

      // tablas
      ventasCombustible: [],
      ventasDespachos: [],
      ventasCanastillaCantidad: [],
      ventasCanastillaVenta: [],

      // series charts
      seriesSemanaCanastilla: [],
      seriesSemanaCombustible: [],
      seriesVentaAnual: [],

      ultima: { total: 0, cantidad: 0, unidad: "" },

      loading: false,

      // charts
      grafico1: null,
      grafico2: null,
      grafico3: null,
      grafico4: null,

      // auto refresh
      intervalId: null,
      chartsLoaded: false,

      // campo fecha que llega en getResumenUltimaSemana()
      WEEK_DATE_KEY: "fecha",

      tanquesCombustible: [],
    };
  },

  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person?.funciones?.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );
    this.dashboardService = new DashboardService();
  },

  mounted() {
    this.initFechas();
    this.startAutoRefresh();
  },

  beforeUnmount() {
    this.stopAutoRefresh();
    this.destroyCharts();
  },

  methods: {
    initFechas() {
      const meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
      const fecha = new Date();
      const pad2 = (n) => (n <= 9 ? "0" + n : "" + n);

      const y = fecha.getFullYear();
      const m = pad2(fecha.getMonth() + 1);
      const d = pad2(fecha.getDate());

      this.fechauno = `${y}-${m}-01 00:00:00`;
      this.fechainicio = `${y}-${m}-${d} 00:00:00`;
      this.fechafin = `${y}-${m}-${d} 23:59:59`;

      this.fechadia = d;
      this.fechames = meses[fecha.getMonth()];
      this.fechaano = "" + y;

      this.anoActual = "" + y;
      this.anoAnterior = "" + (y - 1);
    },

    startAutoRefresh() {
      this.loadDashboard();

      // solo resumen/tablas cada 15s (sin recargar gráficas)
      this.intervalId = setInterval(() => {
        if (this.$route.path.includes("/home")) this.loadResumen();
        else this.stopAutoRefresh();
      }, 13000);
    },

    stopAutoRefresh() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },

    async loadDashboard() {
      await this.loadResumen();

      if (!this.chartsLoaded) {
        await this.loadChartsOnce();
        this.chartsLoaded = true;
      }
    },

    async loadResumen() {
      if (!this.$route.path.includes("/home")) return;

      this.loading = true;
      try {
        const data = await this.dashboardService.getResumenVenta(
          this.person,
          this.fechainicio,
          this.fechauno,
          this.fechafin
        );

        if (!data) return;

        this.cantidadClientes = Number(data.clientes || 0);
        this.cantidadAnuladas = Number(data.anuladas || 0);
        this.cantidadFElectronica = Number(data.electronica || 0);
        this.ultima = data.movimiento || { total: 0, cantidad: 0, unidad: "" };

        const globalComb = Array.isArray(data.global_combustible) ? data.global_combustible : [];
        this.combutibles = globalComb;

        const numeroVentas = globalComb.reduce((acc, x) => acc + Number(x.numero || 0), 0);

        this.totalVentaCombustible = globalComb.reduce((acc, x) => acc + Number(x.total || 0), 0);

        this.cantidadVenta = globalComb.reduce((acc, x) => acc + Number(x.cantidad || 0), 0);

        this.unidadCodigo = globalComb[0]?.unidad_codigo || "";

        if (this.numeroVenta === 0) {
          this.numeroVenta = numeroVentas;
          this.diffVenta = 0;
        } else {
          const delta = numeroVentas - this.numeroVenta;
          this.diffVenta = delta > 0 ? delta : 0;

          if (this.diffVenta > 10) {
            this.numeroVenta = numeroVentas;
            this.diffVenta = 0;
          }
        }

        const globalCan = Array.isArray(data.global_canastilla) ? data.global_canastilla : [];
        this.totalVentaCanastilla = globalCan.reduce((acc, x) => acc + Number(x.total || 0), 0);

        const globalDesp = Array.isArray(data.global_despachos) ? data.global_despachos : [];
        this.ventasDespachos = globalDesp.map((x) => {
          const nombre = String(x.tercero_nombre || "");
          return {
            _id: x._id || `${nombre}-${x.cantidad}-${x.total}`,
            tercero_nombre: nombre.length >= 30 ? nombre.substring(0, 30) : nombre,
            cantidad: Number(x.cantidad || 0),
            total: Number(x.total || 0),
          };
        });

        const combustible = Array.isArray(data.combustible) ? data.combustible : [];
        this.ventasCombustible = combustible.map((x) => ({
          _id: x._id,
          producto_id: x.producto_id,
          producto_nombre: x.producto_nombre,
          numero: Number(x.numero || 0),
          cantidad: Number(x.cantidad || 0),
          total: Number(x.total || 0),
          precio: Number(x.precio || 0),
          unidad_codigo: x.unidad_codigo,
        }));

        const mayorcantidad = Array.isArray(data.mayorcantidad) ? data.mayorcantidad : [];
        this.ventasCanastillaCantidad = mayorcantidad.map((x) => ({
          _id: x._id,
          producto_id: x.producto_id,
          producto_nombre: x.producto_nombre,
          numero: Number(x.numero || 0),
          cantidad: Number(x.cantidad || 0),
          total: Number(x.total || 0),
          precio: Number(x.precio || 0),
          unidad_codigo: x.unidad_codigo,
        }));

        const mayorventa = Array.isArray(data.mayorventa) ? data.mayorventa : [];
        this.ventasCanastillaVenta = mayorventa.map((x) => ({
          _id: x._id,
          producto_id: x.producto_id,
          producto_nombre: x.producto_nombre,
          numero: Number(x.numero || 0),
          cantidad: Number(x.cantidad || 0),
          total: Number(x.total || 0),
          precio: Number(x.precio || 0),
          unidad_codigo: x.unidad_codigo,
        }));


        const tanques = Array.isArray(data.tanques) ? data.tanques : [];
        this.tanquesCombustible = tanques;

      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    async loadChartsOnce() {
      // SEMANALES: mostrar (domingo..hoy) comparando con (domingo..mismo día semana pasada)
      // y para los días posteriores a "hoy" NO mostrar barra en semana actual (null),
      // pero sí mostrar la semana anterior (tal como pediste: mié/jue/vie/sáb solo 24/25/26/27 dic)
      try {
        const semana = await this.dashboardService.getResumenUltimaSemana(this.person);

        if (semana) {
          this.seriesSemanaCombustible = this.buildWeekAlignedToToday(
            semana.combustible,
            this.WEEK_DATE_KEY,
            "total",
            ["#b3b3b3", "#eb0000"]
          );

          this.seriesSemanaCanastilla = this.buildWeekAlignedToToday(
            semana.canastilla,
            this.WEEK_DATE_KEY,
            "total",
            ["#b3b3b3", "#007bff"]
          );

          this.cargarGraficoHistorico();
        }
      } catch (e) {
        console.log(e);
      }

      // anual
      try {
        if (GLOBAL.COUNTRY === "MX") {
          this.seriesVentaAnual = await this.dashboardService.getReporteAnualCredito(this.person);
        } else {
          this.seriesVentaAnual = await this.dashboardService.getReporteAnual(this.person);
        }
        this.cargarGraficoHistoricoAnual();
      } catch (e) {
        console.log(e);
      }
    },

    // ==========================
    // SEMANALES (domingo..hoy) vs (domingo..mismo día semana pasada)
    // Ejemplo si hoy es MAR:
    //  - Semana actual: DOM,LUN,MAR (28,29,30)
    //  - Semana anterior: DOM,LUN,MAR,MIÉ,JUE,VIE,SÁB (21..27)
    //  - Para MIÉ..SÁB: semana actual = null (no barra), semana anterior = valor (24..27)
    // ==========================
    parseOnlyDate(raw) {
      if (!raw) return null;
      const ds = String(raw).trim().substring(0, 10); // YYYY-MM-DD
      const dt = new Date(ds + "T00:00:00");
      return isNaN(dt.getTime()) ? null : dt;
    },

    toDateKey(dt) {
      const y = dt.getFullYear();
      const m = String(dt.getMonth() + 1).padStart(2, "0");
      const d = String(dt.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },

    addDays(dt, n) {
      const d = new Date(dt);
      d.setDate(d.getDate() + n);
      return d;
    },

    buildWeekAlignedToToday(list, dateKey, valueKey, colors) {
      const rows = Array.isArray(list) ? list : [];

      // 1) acumular por día
      const byDay = new Map(); // YYYY-MM-DD -> total
      let maxDt = null;

      for (const r of rows) {
        const dt = this.parseOnlyDate(r?.[dateKey]);
        if (!dt) continue;

        const k = this.toDateKey(dt);
        const v = Number(r?.[valueKey] || 0);
        byDay.set(k, (byDay.get(k) || 0) + v);

        if (!maxDt || dt > maxDt) maxDt = dt;
      }

      if (!maxDt) return [];

      // 2) calcular inicio de semana (domingo) basado en la fecha más reciente del dataset
      const todayDow = maxDt.getDay(); // 0 DOM..6 SAB
      const startCurrent = this.addDays(maxDt, -todayDow); // domingo de la semana "actual"
      const startPrev = this.addDays(startCurrent, -7);    // domingo semana anterior

      // 3) construir arrays DOM..SAB
      const prevArr = new Array(7).fill(0);
      const currArr = new Array(7).fill(null); // null para que NO dibuje barras en días futuros

      for (let dow = 0; dow < 7; dow++) {
        const prevDate = this.addDays(startPrev, dow);
        const prevKey = this.toDateKey(prevDate);
        prevArr[dow] = Number(byDay.get(prevKey) || 0);

        if (dow <= todayDow) {
          const curDate = this.addDays(startCurrent, dow);
          const curKey = this.toDateKey(curDate);
          currArr[dow] = Number(byDay.get(curKey) || 0);
        } else {
          currArr[dow] = null; // NO mostrar miércoles/jueves/viernes/sábado si hoy es martes
        }
      }

      return [
        {
          name: "Semana anterior",
          data: prevArr,
          borderRadiusTopLeft: "3px",
          borderRadiusTopRight: "3px",
          color: colors?.[0] || "#b3b3b3",
        },
        {
          name: "Semana actual",
          data: currArr,
          borderRadiusTopLeft: "3px",
          borderRadiusTopRight: "3px",
          color: colors?.[1] || colors?.[0] || "#eb0000",
        },
      ];
    },

    cargarGraficoHistorico() {
      const dias = ["DOMINGO", "LUNES", "MARTES", "MIERCOLES", "JUEVES", "VIERNES", "SABADO"];

      // asegurar que tome la serie nueva
      if (this.grafico1) { try { this.grafico1.destroy(); } catch (e) { } this.grafico1 = null; }
      if (this.grafico2) { try { this.grafico2.destroy(); } catch (e) { } this.grafico2 = null; }

      if (!this.grafico1) {
        try {
          this.grafico1 = Highcharts.chart("container1", {
            chart: { type: "column" },
            credits: { enabled: false },
            title: { text: "Comparativo Semanal de Ventas Combustible" },
            subtitle: { text: "Semana actual (domingo..hoy) vs semana anterior" },
            xAxis: { categories: dias },
            yAxis: { title: { text: "Totales en pesos" } },
            tooltip: {
              formatter: function () {
                let s = "<b>Comparativo ventas</b><br/>";
                for (let i = 0; i < this.points.length; i++) {
                  const p = this.points[i];
                  const val =
                    p.y === null ? "N/D" : GLOBAL.FORMATO_MONEY_BASIC(p.y);
                  s +=
                    '<span style="color:' +
                    p.color +
                    '">●</span>' +
                    p.series.name +
                    ": <b>" +
                    val +
                    "</b><br/>";
                }
                return s;
              },
              shared: true,
            },
            series: this.seriesSemanaCombustible,
          });
        } catch (e) {
          console.log(e);
        }
      }

      if (!this.grafico2) {
        try {
          this.grafico2 = Highcharts.chart("container2", {
            chart: { type: "column" },
            credits: { enabled: false },
            title: { text: "Comparativo Semanal Ventas Canastilla" },
            subtitle: { text: "Semana actual (domingo..hoy) vs semana anterior" },
            xAxis: { categories: dias },
            yAxis: { title: { text: "Totales en pesos" } },
            tooltip: {
              formatter: function () {
                let s = "<b>Comparativo ventas</b><br/>";
                for (let i = 0; i < this.points.length; i++) {
                  const p = this.points[i];
                  const val =
                    p.y === null ? "N/D" : GLOBAL.FORMATO_MONEY_BASIC(p.y);
                  s +=
                    '<span style="color:' +
                    p.color +
                    '">●</span>' +
                    p.series.name +
                    ": <b>" +
                    val +
                    "</b><br/>";
                }
                return s;
              },
              shared: true,
            },
            series: this.seriesSemanaCanastilla,
          });
        } catch (e) {
          console.log(e);
        }
      }
    },

    // Grafico 3: ENE..DIC comparando año anterior vs actual
    // Grafico 4: LINEAL cronológico YYYY-MM con total_documentos
    cargarGraficoHistoricoAnual() {
      if (!Array.isArray(this.seriesVentaAnual) || !this.seriesVentaAnual.length) return;

      const anoActual = this.anoActual;
      const anoAnterior = this.anoAnterior;

      const mesesNum = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
      const categoriasMes = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];

      const map = new Map();
      for (const it of this.seriesVentaAnual) {
        if (it && it.mes) map.set(String(it.mes), it);
      }

      const getVenta = (yyyy, mm) => {
        const row = map.get(`${yyyy}-${mm}`);
        if (!row) return null;
        return parseFloat(this.formatSalesNum(row.total_ventas));
      };

      const ventasAnterior = mesesNum.map((mm) => getVenta(anoAnterior, mm));
      const ventasActual = mesesNum.map((mm) => getVenta(anoActual, mm));

      if (!this.grafico3) {
        try {
          this.grafico3 = Highcharts.chart("container3", {
            chart: { type: "column" },
            credits: { enabled: false },
            title: { text: "Ventas acumuladas por mes" },
            xAxis: { categories: categoriasMes, title: { text: "Mes" } },
            yAxis: { title: { text: "Totales en pesos" } },
            series: [
              {
                name: anoAnterior,
                data: ventasAnterior,
                color: "#808080",
                dataLabels: {
                  enabled: true,
                  rotation: -90,
                  color: "#FFFFFF",
                  verticalAlign: "top",
                  formatter: function () {
                    return this.y === null ? "" : this.y;
                  },
                },
              },
              {
                name: anoActual,
                data: ventasActual,
                dataLabels: {
                  enabled: true,
                  rotation: -90,
                  color: "#FFFFFF",
                  verticalAlign: "top",
                  formatter: function () {
                    return this.y === null ? "" : this.y;
                  },
                },
              },
            ],
            tooltip: {
              shared: true,
              formatter: function () {
                return (
                  `<b>${this.x}</b><br/>` +
                  this.points
                    .map((p) => `${p.series.name}: ${p.y === null ? "N/D" : "$" + p.y}`)
                    .join("<br/>")
                );
              },
            },
          });
        } catch (e) {
          console.log(e);
        }
      }

      // Grafico 4: lineal cronológico YYYY-MM
      if (!this.grafico4) {
        try {
          const ordenado = [...this.seriesVentaAnual].sort((a, b) =>
            String(a.mes).localeCompare(String(b.mes))
          );

          const categoriasLineal = ordenado.map((x) => x.mes);
          const docsLineal = ordenado.map((x) => Number(x.total_documentos || 0));

          this.grafico4 = Highcharts.chart("container4", {
            chart: { type: "line" },
            credits: { enabled: false },
            title: { text: "Total documentos generados por mes" },
            xAxis: {
              categories: categoriasLineal,
              labels: { rotation: -45 },
            },
            yAxis: {
              title: { text: "Cantidad de documentos" },
              labels: {
                formatter: function () {
                  return Highcharts.numberFormat(this.value, 0, ".", ",");
                },
              },
            },
            series: [
              {
                name: "Documentos por mes",
                data: docsLineal,
                marker: { enabled: true },
                dataLabels: {
                  enabled: true,
                  formatter: function () {
                    return Highcharts.numberFormat(this.y, 0, ".", ",");
                  },
                  style: { fontSize: "11px" },
                },
              },
            ],
            tooltip: {
              formatter: function () {
                return `<b>${this.key}</b><br/>Documentos por mes: ${Highcharts.numberFormat(
                  this.y,
                  0,
                  ".",
                  ","
                )}`;
              },
            },
          });
        } catch (e) {
          console.log(e);
        }
      }
    },

    destroyCharts() {
      try {
        this.grafico1?.destroy();
        this.grafico2?.destroy();
        this.grafico3?.destroy();
        this.grafico4?.destroy();
      } catch (e) {
        // ignore
      } finally {
        this.grafico1 = null;
        this.grafico2 = null;
        this.grafico3 = null;
        this.grafico4 = null;
      }
    },

    formatSalesNum(amount) {
      const n = Number(amount || 0);
      if (GLOBAL.COUNTRY === "CO") return `${(n / 1e6).toFixed(3)}`;
      return `${(n / 1e3).toFixed(0)}`;
    },

    formatSalesText(amount) {
      const n = Number(amount || 0);
      if (GLOBAL.COUNTRY === "CO") return `$${(n / 1e6).toFixed(3)}MLL`;
      return `$${(n / 1e3).toFixed(0)}M`;
    },
  },
};
</script>
